import React from "react";
import {ADotLoader} from "@cisco-sbg-ui/magna-react";
import {t} from "i18next";
import {useSelector} from "react-redux";
import EmptyContent from "components/EmptyContent";
import {
  selectIncidentAuditLog,
  selectIncidentAuditLogLoading
} from "store/selectors";
import AuditLogList from "./AuditLogList";

export default function AuditLogPanel() {
  const loadingIncident = useSelector(selectIncidentAuditLogLoading);
  const auditLog = useSelector(selectIncidentAuditLog);
  const {users} = useSelector((state) => state.users);

  if (loadingIncident) {
    return <ADotLoader className="d-block mx-auto" />;
  } else {
    return auditLog?.length === 0 ? (
      <EmptyContent
        name={t("incidentDetail.worklogTab.auditLogTab").toLowerCase()}
      />
    ) : (
      <AuditLogList auditLog={auditLog} users={users} />
    );
  }
}
